import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ui-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent {
  @Input() isOpen = false;
  @Input() title: string = null;
  @Input() contentStyle: { [key: string]: any } = {};
  @Output() closeDrawer = new EventEmitter<void>();

  onClose() {
    this.closeDrawer.emit();
  }
}
